import React from "react";
import ReactEcharts from "echarts-for-react";

// Function to calculate the linear regression (y = mx + b)
const getLinearTrend = (data) => {
  const n = data.length;
  const x = Array.from({ length: n }, (_, i) => i + 1); // Index as x-axis values
  const y = data;

  // Calculate the sum of x, y, x^2, and xy
  const sumX = x.reduce((acc, val) => acc + val, 0);
  const sumY = y.reduce((acc, val) => acc + val, 0);
  const sumXY = x.reduce((acc, val, idx) => acc + val * y[idx], 0);
  const sumX2 = x.reduce((acc, val) => acc + val * val, 0);

  // Calculate the slope (m) and intercept (b)
  const m = (n * sumXY - sumX * sumY) / (n * sumX2 - sumX * sumX);
  const b = (sumY - m * sumX) / n;

  // Calculate the trend line values (y = mx + b) for each x
  const trendLine = x.map((val) => m * val + b);
  return trendLine;
};

const DebtorsDay2 = () => {
  const dates = [
    "Nov-19", "Dec-19", "Jan-20", "Feb-20", "Mar-20", "Apr-20", "May-20", "Jun-20", "Jul-20", "Aug-20", "Sep-20", "Oct-20",
    "Nov-20", "Dec-20", "Jan-21", "Feb-21", "Mar-21", "Apr-21", "May-21", "Jun-21", "Jul-21", "Aug-21", "Sep-21", "Oct-21",
    "Nov-21", "Dec-21", "Jan-22", "Feb-22", "Mar-22", "Apr-22", "May-22", "Jun-22", "Jul-22", "Aug-22", "Sep-22", "Oct-22",
    "Nov-22", "Dec-22", "Jan-23", "Feb-23", "Mar-23", "Apr-23", "May-23", "Jun-23", "Jul-23", "Aug-23", "Sep-23", "Oct-23",
    "Nov-23", "Dec-23", "Jan-24", "Feb-24", "Mar-24", "Apr-24", "May-24", "Jun-24", "Jul-24", "Aug-24", "Sep-24", "Oct-24"
  ];

  const daysOutstanding = [
    8.9, 5.3, 15.9, 14.3, 9.6, 20.2, 36.1, 25.9, 31.8, 28.3, 30.2, 23.4, 26.0, 29.6, 24.7, 47.0, 18.0, 6.7, 2.7, 2.0, 0.9, 0.7,
    0.5, 0.4, 0.7, 0.3, 0.5, 1.3, 0.9, 0.8, 0.8, 0.2, 0.6, 1.0, 1.6, 1.5, 1.9, 0.7, 1.1, 2.7, 1.6, 1.4, 2.2, 4.5, 1.6, 1.8,
    2.0, 2.3, 3.8, 2.6, 1.9, 1.4, 1.4, 2.9, 4.0, 2.7, 8.5, 7.3, 5.2, 9.3
  ];

  // Calculate the trend line for daysOutstanding
  const trendLineDaysOutstanding = getLinearTrend(daysOutstanding);

  const option = {
    tooltip: { trigger: "axis" },
    legend: { data: ["Days Outstanding", "Trend Line (Days Outstanding)"] },
    xAxis: {
      type: "category",
      data: dates,
      axisLabel: {
        rotate: 45, // Rotate labels to fit better
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: "{value}",
      },
    },
    series: [
      {
        name: "Days Outstanding",
        type: "line",
        data: daysOutstanding,
        smooth: true,
        lineStyle: { color: "blue" },
        markPoint: {
          data: [{ type: "max", name: "Max Value" }, { type: "min", name: "Min Value" }],
        },
      },
      {
        name: "Trend Line (Days Outstanding)",
        type: "line",
        data: trendLineDaysOutstanding,
        smooth: true,
        lineStyle: { type: "dashed", color: "blue" },
      },
    ],
  };

  return <ReactEcharts option={option} style={{ height: "500px" }} />;
};

export default DebtorsDay2;
